<script lang="ts">
	import { onMount } from 'svelte';
	import Typed from 'typed.js';

	type Props = {
		list: string[];
	};

	let { list }: Props = $props();
	let el = $state<HTMLElement>();

	onMount(() => {
		new Typed(el, {
			strings: list.map((w) => w + ` ^500`),
			typeSpeed: 100,
			loop: true,
			showCursor: false,
			backSpeed: 20,
			startDelay: 1000
		});
	});
</script>

<span bind:this={el} class="element"></span>

<style>
	.element {
		display: block;
		min-height: 1.2em;
		line-height: 1.2em;
	}
</style>
